import React, { useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import mainStyle from "../../style/Main.module.css";
import { GoFilter } from "react-icons/go";
import SearchComponent from "../../components/ui/input/Search/Search";
import Button from "../../components/ui/buttons/Button";
import { useNavigate } from "react-router-dom";
import StatusBadge from "../../components/ui/StatusBadge";
import formatDate from "../../components/ui/dateFormat";
import Select from "react-select";
import {
  useEmployeeList,
  useUpdateEmployeeStatus,
} from "../../hooks/useUserList";
import PaginationComponent from "../../components/ui/Pagination/PaginationComponent";
import NoDataFound from "../../components/ui/NoDataFound/NoDataFound";
import PageLoader from "../../components/ui/Loader/PageLoader";
import { FiEdit } from "react-icons/fi";
import EditUserListPage from "./EditUserListPage";
import { statusOptions } from "../../config/selectOptions";
import { useCompanyFilter } from "../../hooks/UseFilter";
import {
  userAddAcess,
  userEdit,
  userStatus,
} from "../../routes/AccessCondition";
import FallbackAvatar from "../../components/ui/FallbackAvatar/FallbackAvatar";

const UserListPage = () => {
  const perPage = 10;
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [showFilter, setShowFilter] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [company, setCompany] = useState("");
  const [search, setSearch] = useState("");
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [datas, setDatas] = useState("");
  const [status, setStatus] = useState("");
  const companyFilter = useCompanyFilter();
  const addAcess = userAddAcess();
  const statusAccess = userStatus();
  const editAccess = userEdit();
  const [imageError, setImageError] = useState({});

  const {
    employees: viewEmployees,
    totalCount: totalEmployeeCount,
    loading: isLoading,
    totalEmpCount,
    refresh: refreshEmployeeList, // Make sure your useEmployeeList hook provides this
  } = useEmployeeList(company, search, currentPage, perPage, status);
  const toggleFilter = () => setShowFilter((prev) => !prev);
  const { updateEmployeeStatus, loading: updateLoading } =
    useUpdateEmployeeStatus();

  const handleAllCheckboxChange = () => {
    if (isAllChecked) {
      setSelectedEmployees([]);
    } else {
      setSelectedEmployees(viewEmployees.map((employee) => employee.id));
    }
    setIsAllChecked(!isAllChecked);
  };

  const handleCheckboxChange = (id) => {
    setSelectedEmployees((prevState) => {
      let newSelected;
      if (prevState.includes(id)) {
        newSelected = prevState.filter((empId) => empId !== id);
      } else {
        newSelected = [...prevState, id];
      }
      setIsAllChecked(newSelected.length === viewEmployees.length);

      return newSelected;
    });
  };

  const currentPageNo = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };

  const handleSearch = (term) => {
    if (term !== search) {
      setSearch(term);
      setCurrentPage(1);
    }
  };

  const handleCompanyFilter = (option) => {
    if (option?.value !== company) {
      setCompany(option.value);
      setCurrentPage(1);
    }
  };

  const handleStatusUpdate = async (statusType) => {
    try {
      await updateEmployeeStatus(selectedEmployees, statusType);
      refreshEmployeeList(); // reload list
      setSelectedEmployees([]); // clear selection
      setIsAllChecked(false);
    } catch (error) {
      // console.error("Error updating status:", error.message);
    }
  };

  const handleFilterChange = (selectedOption) => {
    const newStatus = selectedOption ? selectedOption.value : "";
    if (newStatus !== status) {
      setStatus(newStatus);
      setCurrentPage(1);
    }
  };

  const addUserPage = () => {
    navigate("/userlist/add");
  };

  const openEditPage = (employee) => {
    setDatas(employee);
    // console.log(employee);
    setOpenEdit(true); // Open the modal
    setSelectedEmployee(employee); // Set the employee to be edited
  };

  const closeEditPage = () => {
    setOpenEdit(false);
    setSelectedEmployee(null);
    refreshEmployeeList(); // Refresh the list after editing
  };

  return (
    <>
      <MainLayout>
        <div className={mainStyle.mainPageHeader}>
          {selectedEmployees.length === 0 ? (
            <>
              <div>
                <p>User List</p>
              </div>
              <div className={mainStyle.mainPageButtons}>
                <SearchComponent onSearch={handleSearch} />
                {addAcess && (
                  <Button onClick={() => navigate("/userlist/add")}>
                    Add Users
                  </Button>
                )}

                <button
                  className={mainStyle.FilterButton}
                  onClick={toggleFilter}
                >
                  <GoFilter /> Filter
                </button>
              </div>
            </>
          ) : (
            <>
              <div></div>
              <div className={mainStyle.mainPageButtons}>
                <Button
                  variant="outline-success"
                  onClick={() => handleStatusUpdate("0")}
                  disabled={updateLoading || selectedEmployees.length === 0}
                >
                  Active
                </Button>
                <Button
                  variant="outline-danger"
                  disabled={updateLoading || selectedEmployees.length === 0}
                  onClick={() => handleStatusUpdate("1")}
                >
                  Deactive
                </Button>
              </div>
            </>
          )}
        </div>

        {showFilter && (
          <div className={mainStyle.mainPageFilter}>
            <div className={mainStyle.mainPageFilterSub}>
              <div className={mainStyle.mainPageFilterDiv}>
                <span>Company</span>
                <Select
                  className={mainStyle.pagesFilter}
                  placeholder="Select Company"
                  options={companyFilter}
                  onChange={handleCompanyFilter}
                  value={companyFilter.find(
                    (option) => option.value === company
                  )}
                />
              </div>
              <div className={mainStyle.mainPageFilterDiv}>
                <span>Status</span>
                <Select
                  className={mainStyle.pagesFilter}
                  placeholder="Action"
                  options={statusOptions}
                  onChange={handleFilterChange}
                  value={statusOptions.find(
                    (option) => option.value === status
                  )}
                />
              </div>
              {/* <div>
                <p> Total Employee {totalEmpCount}</p>
              </div> */}
              {/* Option 1: Card Design */}

              {/* Option 2: Badge Design */}
              <div className={mainStyle.mainPageFilterDiv}>
                <span>Total User Count</span>
                <div className={mainStyle.totalEmployeeBadge}>
                  <span className={mainStyle.badgeLabel}>User:</span>
                  <span className={mainStyle.badgeCount}>{totalEmpCount}</span>
                </div>
              </div>

              {/* Option 3: Minimal Design */}
            </div>
          </div>
        )}

        <div
          className={mainStyle.mainContentView}
          style={{ height: showFilter ? "78%" : "92%" }}
        >
          {isLoading ? (
            <PageLoader />
          ) : (
            <div className={mainStyle.mainContentViewsb}>
              {viewEmployees && viewEmployees.length > 0 ? (
                <div className={mainStyle.mainTableDiv}>
                  <table className={mainStyle.mainTable}>
                    <thead className={mainStyle.mainTableHead}>
                      <tr>
                        {statusAccess && (
                          <th>
                            <input
                              type="checkbox"
                              checked={isAllChecked}
                              onChange={handleAllCheckboxChange}
                            />
                          </th>
                        )}
                        <th>User</th>
                        <th>Phone</th>
                        <th>Company</th>
                        <th>Status</th>
                        <th>Joining Date</th>
                        {editAccess && <th>##</th>}
                      </tr>
                    </thead>

                    <tbody className={mainStyle.mainTableBody}>
                      {viewEmployees.map((emp, index) => (
                        <tr key={emp.id || index}>
                          {statusAccess && (
                            <td>
                              <input
                                type="checkbox"
                                checked={selectedEmployees.includes(emp.id)}
                                onChange={() => handleCheckboxChange(emp.id)}
                              />
                            </td>
                          )}

                          <td>
                            <div className={mainStyle.tableImgViewdiv}>
                              <div>
                                <div className={mainStyle.tableImgView}>
                                  {imageError[emp.id] &&
                                  emp.emp_pic === null ? (
                                    <FallbackAvatar
                                      name={`${emp.first_name} ${emp.last_name}`}
                                      size={40}
                                    />
                                  ) : (
                                    <img
                                      src={`${apiUrl}${emp.emp_pic}`}
                                      alt="img"
                                      onError={() =>
                                        setImageError((prev) => ({
                                          ...prev,
                                          [emp.id]: true,
                                        }))
                                      }
                                    />
                                  )}
                                </div>
                              </div>
                              <div className={mainStyle.tableImgViewContent}>
                                <div
                                  className={mainStyle.tableImgViewContentName}
                                >
                                  {`${emp.first_name} ${emp.last_name}`}
                                </div>
                                <div
                                  className={mainStyle.tableImgViewContentEmail}
                                >
                                  {emp.email}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>{emp.phone}</td>
                          <td>
                            {emp.company_name &&
                              emp.company_name.length > 0 && (
                                <div
                                  className={mainStyle.companyLogosContainer}
                                >
                                  {emp.company_name
                                    .slice(0, 3)
                                    .map((company, i) => (
                                      <img
                                        key={i}
                                        src={`${apiUrl}${company.company_logo}`}
                                        alt={company.name}
                                        className={mainStyle.companyLogo}
                                      />
                                    ))}
                                  {emp.company_name.length > 3 && (
                                    <div
                                      className={
                                        mainStyle.moreCompaniesIndicator
                                      }
                                    >
                                      +{emp.company_name.length - 3}
                                    </div>
                                  )}
                                </div>
                              )}
                          </td>
                          <td>
                            <StatusBadge status={emp.active_status} />
                          </td>
                          <td>{formatDate(emp.join_date)}</td>
                          {editAccess && emp.active_status === "0" && (
                            <td>
                              <FiEdit
                                onClick={() => openEditPage(emp)}
                                style={{ cursor: "pointer" }}
                              />
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <NoDataFound
                  title="No User Found"
                  description="No User found. Click the button below to add a new."
                  buttonText="Add Users"
                  onButtonClick={addUserPage}
                />
              )}

              <div>
                {!isLoading && totalEmployeeCount > perPage && (
                  <PaginationComponent
                    pageCount={Math.ceil(totalEmployeeCount / perPage)}
                    onPageChange={currentPageNo}
                    forcePage={currentPage - 1}
                  />
                )}
              </div>
            </div>
          )}
        </div>

        {/* Edit Modal */}
      </MainLayout>
      {openEdit && (
        <EditUserListPage
          data={datas}
          show={openEdit}
          onClose={closeEditPage}
          employee={selectedEmployee}
        />
      )}
    </>
  );
};

export default UserListPage;
